import { cloneDeep } from 'lodash';
import Request from 'noc/common/request';
import { SendEventToGA } from 'noc/common/googleAnalytics';
import * as ActionTypes from 'noc/tickets/types';
import store from 'noc/store';
import Icon from 'noc/components/icon';
import classNames from 'classnames';

function getTicketServiceApiUrl() {
    return window.getTicketServiceApiUrl();
}

function getTicketsUrl() {
    return `${getTicketServiceApiUrl()}api/tickets`;
}

function getUsersUrl() {
    return `${getTicketServiceApiUrl()}api/users`;
}

function getSessionValidationUrl() {
    return `${window.getSessionAutenticatedkey()}api/UserSession`;
}

function getPrintTicketUrl() {
    return `${window.getNOCPortalUrl()}noc/TaskServiceReportnew.asp?`;
}

function getOpenTicketUrl() {
    return `${window.getTicketViewTab()}`;
}

function getAllTicketData() {
    // return `${window.getAllTicketData()}`;
    return `${getTicketServiceApiUrl()}api/tickettrackingdashboard`;
}

function getTicketTechData() {
    // return `${window.getTicketTechData()}`;
    return `${getTicketServiceApiUrl()}api/TicketTech`;
}
function getOwnerTeamData() {
    // return `${window.getOwnerTeamData()}`;
    return `${getTicketServiceApiUrl()}api/OwnerTeam`;
}

function getTicketCategoryData() {
    //return `${window.getOwnerTeamData()}`;
    //return `${getTicketServiceApiUrl()}api/TicketCategory`;
    return `${getTicketServiceApiUrl()}api/TicketAllCategory`;
}

function getTicketCountData() {
    return `${getTicketServiceApiUrl()}api/tickettrackingdashboard`;
}

function isOpenAMEnabled() {
    return window.isOpenAMEnabled();
}

function isOpenAMPlusEnabled() {
    return window.isOpenAMPlusEnabled();
}

export function buildQueryParams(skip, take, filter, requestFor,
    advanceSearches, sortOrder, ownerTeamId, cellId) {
    const genericSearch = filter;
    const projectName = 'TTD';
    const sortOrders = sortOrders === null ? store.getState().tickets.sortOrders : sortOrder;

    return {
        genericSearch,
        skip,
        take,
        requestFor,
        sortOrders,
        advanceSearches,
        projectName,
        ownerTeamId,
        cellId
    };
}

export function getAllData(checked, TicketId) {
    let ticketCheckboxArray = store.getState().tickets.ticketCheckboxArray;
    if (checked === true) {
        ticketCheckboxArray.push(parseInt(TicketId, 10));
    } else {
        ticketCheckboxArray = ticketCheckboxArray.filter(item => item !== parseInt(TicketId, 10));
    }
    return dispatch => {
        dispatch({
            ticketCheckboxArray,
            type: ActionTypes.TICKET_CHECKBOX_ARRAY
        });
    };
}


export function loadArray(ticketCheckboxArray) {
    return {
        ticketCheckboxArray,
        type: ActionTypes.TICKET_CHECKBOX_ARRAY
    };
}
export function clearTicketsSelection() {
    const ticketCheckboxArray = store.getState().tickets.ticketCheckboxArray;
    ticketCheckboxArray.length = 0;
    return dispatch => {
        dispatch(loadArray(ticketCheckboxArray));
    };
}

//test test test
export function fetchTicketCountData(requestForId) {
    const key = store.getState().tickets.Enckey;
    const tab = store.getState().tickets.tabsData.find(x => x.Id === requestForId);
    const advanceSearch = tab.AdvanceSearch;
    const ticketsIds = [];
     for (let i = 0; i < store.getState().tickets.ticketCheckboxArray.length; i++) {
         const jsObj = {};
         jsObj.TicketID = store.getState().tickets.ticketCheckboxArray[i];
         jsObj.ThresholdID = store.getState().tickets.ticketsData.find(c => c.TicketId === store.getState().tickets.ticketCheckboxArray[i]).ThresholdID;
         jsObj.UserID = store.getState().tickets.UserDetails.UserId;
         jsObj.BreachCount_Up = store.getState().tickets.ticketsData.find(c => c.TicketId === store.getState().tickets.ticketCheckboxArray[i]).BreachCount_Up;
         ticketsIds.push(jsObj);
     }

    const data = { ParamterId: requestForId, TicketIds: ticketsIds };

    return dispatch => {
       Request.put(getTicketCountData(), { key, data }).then(result => {
                dispatch(fetchTicketCategoryData());
                dispatch(fetchTicketsData(0,
                    store.getState().tickets.pageSize,
                    null,
                    null,
                    null,
                    requestForId,
                    advanceSearch,
                    null, false, 1));
                dispatch(hideAllPopUp({ hideFilterMenu: !isFilterAppliedAndRecordsPresent() }));
                dispatch(clearTicketsSelection());
        });
    };
}

export function buildProjectNameParam() {
    const projectName = 'TTD';
    return {
        projectName
    };
}

export function loadTicketsData(startIndex,
    pageSize, filter, sortColumn, sortDirection, requestForId, advanceSearch,
    sortOrders, newTicketsData, totalCount, pageNumber, tabsData, clearTicketsData) {
    const ticketsData = clearTicketsData ? store.getState().tickets.ticketsData : newTicketsData;

    if (clearTicketsData === true) {
        newTicketsData.forEach(function (rowItem, i) {
            ticketsData.push(rowItem);
        });
    }
    let errorMessage;
    let errorTitle;
    let showErrorMessage = false;

    if (ticketsData == null || ticketsData.length <= 0) {
        errorMessage = 'No Records Found';
        errorTitle = 'No Records Found';
        showErrorMessage = true;
    }

    const startTime = Date.now();
    const elapsed = 0;
    const showLoginErrorMessage = false;
    return {
        startIndex,
        pageSize,
        filter,
        sortColumn,
        sortDirection,
        requestForId,
        advanceSearch,
        sortOrders,
        ticketsData,
        totalCount,
        pageNumber,
        showErrorMessage,
        errorMessage,
        errorTitle,
        showLoginErrorMessage,
        tabsData,
        elapsed,
        startTime,
        type: ActionTypes.LOAD_DATA
    };
}

export function loadErrorMessage(errorTitle, errorMessage, showLoginError, showErrorMessage) {
    return {
        showErrorMessage,
        showLoginError,
        errorMessage,
        errorTitle,
        type: ActionTypes.LOAD_ERROR_MESSSAGE
    };
}

export function fetchOwnerTeamData() {
    const key = store.getState().tickets.Enckey;
    return dispatch => {
        Request.get(getOwnerTeamData(), { key }).then(data => {
            if (data != null) {
                const userDetails = store.getState().tickets.UserDetails;
                const tickets = store.getState().tickets;
                userDetails.OwnerTeamId = data.OwnerTeamData.ownerTeamList.find(x => x.NocTeamId == -1) != null ? -1 : data.OwnerTeamData.ownerTeamList[0].NocTeamId;
                userDetails.CellId = data.OwnerTeamData.cellList.find(x => x.CellId == -1) != null ? -1 : data.OwnerTeamData.cellList[0].CellId;
                tickets.IsSLM = userDetails.OwnerTeamId === -1 ? true : false;
                tickets.IsSLMOwnerTeam= userDetails.OwnerTeamId === -1 ? true : false;
                dispatch(loadOwnerTeamData(data.OwnerTeamData.ownerTeamList));
                dispatch(loadCellData(data.OwnerTeamData.cellList));
                dispatch(fetchTicketTechData(userDetails.OwnerTeamId));
                dispatch(fetchTicketCategoryData(userDetails.OwnerTeamId, userDetails.CellId));
                dispatch(fetchTicketsData(
                    store.getState().tickets.startIndex,
                    store.getState().tickets.pageSize, null,
                    store.getState().tickets.sortColumn,
                    store.getState().tickets.sortDirection,
                    store.getState().tickets.requestForId, null, null, false, 1, userDetails.OwnerTeamId, userDetails.CellId));
            }
        });
    }
}

export function hideAllPopUp({ hideFilterMenu }) {
    const columnFilters = store.getState().tickets.columnFilters;

    if (hideFilterMenu === true) {
        columnFilters.forEach(columnfilter => {
            columnfilter.isStatus = false;
        });
    } else if (hideFilterMenu === undefined || hideFilterMenu === false) {
        columnFilters.forEach(columnfilter => {
            columnfilter.isStatus = columnfilter.eventName === 'TabFilter';
        });
    }

    return {
        columnFilters,
        type: ActionTypes.TOGGLE_MENU
    };
}

function isFilterAppliedAndRecordsPresent() {
    const tabsData = store.getState().tickets.tabsData;
    const requestForId = store.getState().tickets.requestForId;
    const tab = tabsData.find(x => x.Id === requestForId);

    if (!store.getState().tickets.ticketCategoryData) {
        return tab.AdvanceSearch.length > 0;
    }

    const ticketCategoryData = store.getState().tickets.ticketCategoryData;
    let tileCategory = null;

    if (ticketCategoryData !== null && ticketCategoryData !== undefined) {
        tileCategory = ticketCategoryData.find(
            category => category.Id === parseInt(requestForId, 10)
        );
        if (tileCategory) {
            return tab.AdvanceSearch.length > 0 && tileCategory.TotalCount > 0;
        }
    }

    return tab.AdvanceSearch.length > 0;
}

export function changeOwnerTeam(ownerTeamId) {
    const userDetails = store.getState().tickets.UserDetails;
    const tickets = store.getState().tickets;
    userDetails.OwnerTeamId = ownerTeamId;
    return dispatch => {
        tickets.IsSLM = ownerTeamId === "-1" ? true : false;
        dispatch(loadUserDetails(userDetails));
        dispatch(hideAllPopUp({ hideFilterMenu: !isFilterAppliedAndRecordsPresent() }));
    };
}

export function changeCell(cellId) {
    const userDetails = store.getState().tickets.UserDetails;
    const tickets = store.getState().tickets;
    userDetails.CellId = cellId;
    return dispatch => {
        dispatch(loadUserDetails(userDetails));
        dispatch(hideAllPopUp({ hideFilterMenu: !isFilterAppliedAndRecordsPresent() }));
    };
}

function showLoader(isDataLoading) {
    const dataRequestsTokens = store.getState().tickets.dataRequestsTokens;
    if (isDataLoading) {
        dataRequestsTokens.push(dataRequestsTokens.length);
    } else {
        dataRequestsTokens.pop();
    }

    return {
        dataRequestsTokens,
        type: ActionTypes.SHOW_HIDE_LOADER
    };
}

export function refreshTechnician(resetTimer) {
    return dispatch => {
        if (resetTimer === undefined || resetTimer === true) {
            dispatch(startResetTimer('ticketTechniciansPanel'));
        }

        dispatch(hideAllPopUp({ hideFilterMenu: !isFilterAppliedAndRecordsPresent() }));
        dispatch(fetchTicketTechData());
        dispatch(clearTicketsSelection());
    };
}

export function refreshGrid(resetTimer) {
    const requestForId = store.getState().tickets.requestForId;
    const tabsData = store.getState().tickets.tabsData;
    const tab = tabsData.find(x => x.Id === requestForId);

    return dispatch => {
        if (resetTimer === undefined || resetTimer === true) {
            dispatch(startResetTimer('notificationsPanel'));
        }

        dispatch(hideAllPopUp({ hideFilterMenu: !isFilterAppliedAndRecordsPresent() }));
        dispatch(fetchTicketCategoryData());
        dispatch(fetchTicketsData(
            0,
            store.getState().tickets.pageSize,
            store.getState().tickets.filter,
            null, null, requestForId, tab.AdvanceSearch,
            store.getState().tickets.sortOrders, false, 1));
        dispatch(clearTicketsSelection());
    };
}

function startResetTimer(panelName) {
    const timerDetails = store.getState().tickets.timers;

    return dispatch => {

        if (timerDetails[panelName] != null) {
            clearInterval(timerDetails[panelName]);
        }
        if (panelName === 'ticketTechniciansPanel') {

            timerDetails.ticketTechniciansPanel = setInterval(() => {
                dispatch(refreshTechnician(false));
                dispatch(clearTicketsSelection());
            }, getAutoRefreshTimeout());
        }
        if (panelName === 'notificationsPanel') {
            timerDetails.notificationsPanel = setInterval(() => {
                dispatch(refreshGrid(false));
                dispatch(clearTicketsSelection());
            }, getAutoRefreshTimeout());
        }

        dispatch({
            timerDetails,
            type: ActionTypes.START_RESET_TIMER
        });
    }
}

export function loadTicketCategoryData(ticketCategoryData) {
    const now = new Date();
    const refreshGridTime = now.toTimeString().split(' ')[0];
    const refreshCategoryGridTime = refreshGridTime;

    return {
        ticketCategoryData,
        refreshCategoryGridTime,
        type: ActionTypes.LOAD_TICKETCATEGORY_DATA
    };
}

export function fetchTicketCategoryData(ownerTeamId, cellId) {
    const key = store.getState().tickets.Enckey;
    const queryParams = { ownerTeamId: ownerTeamId != null ? ownerTeamId : store.getState().tickets.UserDetails.OwnerTeamId, cellId: cellId != null ? cellId : store.getState().tickets.UserDetails.CellId };

    return dispatch => {
        dispatch(showLoader(true));
        Request.get(getTicketCategoryData(), { queryParams, key }).then(data => {
            if (data != null) {
                dispatch(loadTicketCategoryData(data.TicketCategoryDTo));
            }
            dispatch(showLoader(false));
        });
    }
}

// export function fetchTicketCategoryData(ownerTeamId) {
//     const key = store.getState().tickets.Enckey;
//     const TicketCategoryDTo = [];

//     return dispatch => {
//         const isVisibleTabs = store.getState().tickets.tabsData.filter(x => x.IsVisible);

//         for (let i = 0; i < isVisibleTabs.length; i++) {

//             const requestFor = isVisibleTabs[i].Id;
//             const queryParams = {
//                 requestFor,
//                 ownerTeamId: ownerTeamId != null
//                             ? ownerTeamId
//                             : store.getState().tickets.UserDetails.OwnerTeamId
//             };

//             dispatch(showLoader(true));
//             Request.get(getTicketCategoryData(), { queryParams, key }).then(data => {
//                 if (data != null) {
//                     TicketCategoryDTo.push(data);
//                     dispatch(loadTicketCategoryData(TicketCategoryDTo));
//                     dispatch(showLoader(false));
//                 }
//             });
//         }
//     };
// }

export function loadTicketSectionData(TicketPlayStatusData) {
    const now = new Date();
    const lastUpdatedTime = now.toTimeString().split(' ')[0];
    TicketPlayStatusData.RefreshTime = lastUpdatedTime;
    return {
        TicketPlayStatusData,
        type: ActionTypes.LOAD_TICKET_DATA
    };
}

export function loadTechData(TechStatusData) {
    return {
        TechStatusData,
        type: ActionTypes.LOAD_TECH_DATA
    };
}

export function fetchTicketTechData(ownerTeamId) {

    const key = store.getState().tickets.Enckey;
    const queryParams = {
        ownerTeamId: ownerTeamId != null
            ? ownerTeamId
            : store.getState().tickets.UserDetails.OwnerTeamId
    };

    return dispatch => {
        dispatch(showLoader(true));
        Request.get(getTicketTechData(), { queryParams, key }).then(data => {
            if (data != null) {
                dispatch(loadTicketSectionData(data.TicketPlayStatusData));
                dispatch(loadTechData(data.TechStatusData));
            }
            dispatch(showLoader(false));
            dispatch(clearTicketsSelection());
        });
    };
}

export function fetchTicketsData(startIndex,
    pageSize, filter, sortColumn, sortDirection, requestForId,
    advanceSearch, sortOrders, clearTicketsData, pageNumber, ownerTeamId, cellId) {
    const key = store.getState().tickets.Enckey;

    if (requestForId === '' || requestForId === undefined || requestForId === null) {
        requestForId = store.getState().tickets.requestForId;
    }

    const tabsData = store.getState().tickets.tabsData;
    const tab = tabsData.find(x => x.Id === requestForId);

    const now = new Date();
    const refreshGridTime = now.toTimeString().split(' ')[0];
    tab.RefreshGridTime = refreshGridTime;

    ownerTeamId = (ownerTeamId === '' || ownerTeamId === undefined || ownerTeamId === null) ? store.getState().tickets.UserDetails.OwnerTeamId : ownerTeamId;
    cellId = (cellId === '' || cellId === undefined || cellId === null) ? store.getState().tickets.UserDetails.CellId : cellId;

    const requestFor = tab.Name;
    // const tabsData = store.getState().tickets.tabsData;
    // const OwnerTeamId = tabsData.find(x => x.OwnerTeam === 1).Id;
    // advanceSearch = OwnerTeamId
    return dispatch => {
        dispatch(showLoader(true));
        const queryParams = buildQueryParams(startIndex,
            pageSize, filter, requestFor, advanceSearch, sortOrders, ownerTeamId, cellId);

        Request.get(getAllTicketData(), { queryParams, key }).then(data => {
            if (data === null) {
                dispatch(loadErrorMessage('Some error occurred', 'There is some error occurred, we are working towards it.', false, true));
            }

            if (data !== null) {
                if (!(data == null) && data.IsError !== undefined && data.IsError !== null) {
                    dispatch(loadErrorMessage(data.Message, data.Description, false, true));
                } else {
                    const ticketsData = data.TotalFilteredRecords <= 0 ? [] : data.Items;
                    const totalCount = data.TotalRecords;

                    tab.QueueViewGrid.TotalRecords = totalCount;
                    dispatch(loadTicketsData(startIndex,
                        pageSize, filter, sortColumn, sortDirection, requestForId,
                        advanceSearch,
                        data.SortOrders,
                        ticketsData,
                        totalCount,
                        pageNumber,
                        tabsData, clearTicketsData));

                    dispatch(hideAllPopUp({ hideFilterMenu: !isFilterAppliedAndRecordsPresent() }));

                    SendEventToGA('Tab Selection', 'Tab View Selected', `${requestForId} Total-Counts :${totalCount}`, null);
                }
            }
            dispatch(showLoader(false));
        });
    };
}

export function dataSort(sortColumn, sortDirectionValue) {
    const sortDirection = sortDirectionValue === 'Asc' ? 'Desc' : 'Asc';
    const sortOrderDto = { ColumnName: sortColumn, ColumnOrder: sortDirection };
    const sortOrders = [sortOrderDto];

    return dispatch => {
        dispatch(
            fetchTicketsData(
                0,
                store.getState().tickets.pageSize,
                store.getState().tickets.filter,
                sortColumn,
                sortDirection,
                store.getState().tickets.requestForId,
                store.getState().tickets.advanceSearch,
                sortOrders,
                false,
                1
            )
        );
    };
}

function saveFilterInfo() {
    const tabsData = store.getState().tickets.tabsData;
    const requestForId = store.getState().tickets.requestForId;
    const currentTab = tabsData.find(x => x.Id === requestForId);

    const filterPreviousData = store.getState().tickets.filterPreviousData;
    filterPreviousData.advanceSearchDetails = cloneDeep(currentTab.AdvanceSearch);

    tabsData.forEach(tab => {
        if (tab.Id === requestForId) {
            return;
        }
        tab.AdvanceSearch = cloneDeep(filterPreviousData.advanceSearchDetails);
    });

    return {
        filterPreviousData,
        tabsData,
        type: ActionTypes.SAVE_FILTER_INFO
    };
}

function undoFilterInfo() {
    const tabsData = store.getState().tickets.tabsData;
    const filterPreviousData = store.getState().tickets.filterPreviousData;
    const requestForId = store.getState().tickets.requestForId;
    const tabToUndo = tabsData.find(x => x.Id === requestForId);

    if (filterPreviousData.isFilterSelectionInProgress) {
        tabToUndo.AdvanceSearch = cloneDeep(
            filterPreviousData.advanceSearchDetails
        );
        filterPreviousData.isFilterSelectionInProgress = false;
    }

    return {
        tabsData,
        filterPreviousData,
        type: ActionTypes.UNDO_FILTER_INFO
    };
}

export function getTabData(requestForId) {
    const tab = store.getState().tickets.tabsData.find(x => x.Id === requestForId);
    const advanceSearch = tab.AdvanceSearch;

    return dispatch => {
        dispatch(undoFilterInfo());
        dispatch(fetchTicketCategoryData());
        dispatch(fetchTicketsData(0,
            store.getState().tickets.pageSize,
            null,
            null,
            null,
            requestForId,
            advanceSearch,
            null, false, 1));
        dispatch(hideAllPopUp({ hideFilterMenu: !isFilterAppliedAndRecordsPresent() }));
        dispatch(clearTicketsSelection());
    };
}

export function dataSearch(search, requestForId, tabsData) {
    const tab = tabsData.find(x => x.Id === requestForId);
    const advanceSearch = tab.AdvanceSearch;
    SendEventToGA('Search Category', 'Generic Search', `Search Content: ${search}`, null);
    return dispatch => {
        dispatch(fetchTicketsData(0,
            store.getState().tickets.pageSize,
            search,
            null,
            null,
            null,
            advanceSearch,
            store.getState().tickets.sortOrders, false, 1));
    };
}

export function loadEncryptedkey(Enckey) {
    return {
        Enckey,
        type: ActionTypes.LOAD_ENCDATA
    };
}

export function loadUserData(tabsData) {
    const tab = tabsData.find(x => x.Sequence === 1);
    const requestForId = tab.Id;

    return {
        requestForId,
        tabsData,
        type: ActionTypes.LOAD_USER_DATA
    };
}

export function loadOwnerTeamData(OwnerTeamData) {
    return {
        OwnerTeamData,
        type: ActionTypes.LOAD_OWNERTEAM_DATA
    };
}

export function loadCellData(CellData) {
    return {
        CellData,
        type: ActionTypes.LOAD_CELL_DATA
    };
}

export function loadEmptyData(ticketsData) {
    return {
        ticketsData,
        type: ActionTypes.LOAD_EMPTY_DATA
    };
}

export function loadUserDetails(UserDetails) {
    return {
        UserDetails,
        type: ActionTypes.PRINT_TICKET
    };
}

export function fetchUserDefaults() {
    const key = store.getState().tickets.Enckey;
    const queryParams = buildProjectNameParam();
    
    return dispatch => {
        Request.get(getUsersUrl(), { queryParams, key }).then(tabsData => {
            if (tabsData.Tabs != null) {
                dispatch(fetchOwnerTeamData());
                dispatch(loadUserData(tabsData.Tabs));
                dispatch(loadUserDetails(tabsData.UserDetails));

                // const tabsData = store.getState().tickets.tabsData;
                // const OwnerTeamId = tabsData.find(x => x.OwnerTeam === 1).Id;
            }
        });
    };
}


export function getAuthenticatedUnquieKey(key) {
    return dispatch => {
        if (isOpenAMEnabled()) {
           
                dispatch(loadEncryptedkey(key));
                dispatch(fetchUserDefaults());
            
        }
        else {
            if (key != null) {
                Request.get(getSessionValidationUrl(), { key }).then(Enckey => {
                    if (Enckey != null) {
                        dispatch(loadEncryptedkey(Enckey));
                        dispatch(fetchUserDefaults());
                    }
                });
            } else {
                dispatch(loadErrorMessage('Login in NOC', 'Please login in NOC to access TTD', true, false));
            }
        }
    };
}

export function toggle(columnFilters, itemNameToBeToggled) {
    const columnFilterToBeToggled = columnFilters.find(
        x => x.eventName === itemNameToBeToggled
    );
    columnFilterToBeToggled.isStatus = !columnFilterToBeToggled.isStatus;

    const filterPreviousData = store.getState().tickets.filterPreviousData;

    columnFilters
        .filter(x => x.groupId === columnFilterToBeToggled.groupId)
        .map(columnfilter => {
            if (columnfilter.eventName !== columnFilterToBeToggled.eventName) {
                if (
                    columnfilter.isStatus &&
                    filterPreviousData.isFilterSelectionInProgress
                ) {
                    undoFilterInfo();
                }

                columnfilter.isStatus = false;
            }
            columnFilters
                .filter(x => x.parentId === columnfilter.id)
                .forEach(childcolumnfilter => {
                    childcolumnfilter.isStatus = false;
                });
        });

    return {
        columnFilters,
        type: ActionTypes.TOGGLE_MENU
    };
}

export function updateStartIndex() {
    return {
        type: ActionTypes.UPDATE_START_INDEX
    };
}

export function pageNumberChange(pageNumber, footerPosition) {
    const requestForId = store.getState().tickets.requestForId;
    const tabsData = store.getState().tickets.tabsData;
    const tab = tabsData.find(x => x.Id === requestForId);

    return dispatch => {
        dispatch({ pageNumber, footerPosition, type: ActionTypes.PAGE_NUMBER_CHANGE });
        dispatch(fetchTicketsData(
            (store.getState().tickets.startIndex + store.getState().tickets.pageSize),
            store.getState().tickets.pageSize,
            null, store.getState().tickets.sortColumn, store.getState().tickets.sortDirection,
            store.getState().tickets.requestForId, tab.AdvanceSearch,
            store.getState().tickets.sortOrders, true, pageNumber));
    };
}

// export function pageSizeChange(pageSize) {
//    return dispatch => {
//        dispatch({ pageSize, pageNumber: 0, type: ActionTypes.PAGE_SIZE_CHANGE });
//        dispatch(fetchTicketsData(store.getState().tickets.startIndex, pageSize,
//            null, store.getState().tickets.sortColumn, store.getState().tickets.sortDirection,
//            store.getState().tickets.requestForId, store.getState().tickets.AdvanceSearch,
//            store.getState().tickets.sortOrders, false, 1));
//        dispatch(updateStartIndex());
//    };
// }

export function loadUserSessionData(totalSessionCount) {
    return {
        totalSessionCount,
        type: ActionTypes.LOAD_USERSESSION_DATA
    };
}

export function updateTabDetails(data) {
    const key = store.getState().tickets.Enckey;
    Request.put(getUsersUrl(), { key, data });
    return dispatch => {
        dispatch(fetchTicketsData(
            store.getState().tickets.startIndex,
            store.getState().tickets.pageSize, null,
            store.getState().tickets.sortColumn,
            store.getState().tickets.sortDirection,
            store.getState().tickets.requestForId, null, null, false, 1));
    };
}

export function onCheckedOfColumnFilter(tabsData, requestForId, headerName,
    isFilterChecked, isFilter, filterName, filterId) {
    const tab = tabsData.find(x => x.Id === requestForId);
    const filterPreviousData = store.getState().tickets.filterPreviousData;

    tab.QueueViewGrid.Columns.map(header => {
        if (header.Id === filterId
            || header.Id === headerName
            || headerName === 'All'
            || headerName === 'None') {

            if (isFilter) {
                let advanceSearch = tab.AdvanceSearch.find(x => x.PropertyValue === headerName
                    && x.PropertyName === filterName);

                const allFilters = tab.QueueViewGrid.GridFilters.find(x => x.FilterId === filterId);
                const filter = allFilters.FilterData.find(x => x.Id === headerName);
                header.IsFiltered = !isFilterChecked;
                if (!filterPreviousData.isFilterSelectionInProgress) {
                    filterPreviousData.isFilterSelectionInProgress = true;
                    filterPreviousData.advanceSearchDetails = cloneDeep(tab.AdvanceSearch);
                }

                if (filter !== undefined) filter.IsFiltered = !isFilterChecked;

                if (advanceSearch === undefined
                    && header.IsFiltered
                    && (headerName !== 'All'
                        && headerName !== 'None')) {

                    tab.AdvanceSearch.push({ PropertyName: filterName, PropertyValue: headerName });
                } else if (advanceSearch !== undefined
                    && !header.IsFiltered
                    && (headerName !== 'All'
                        && headerName !== 'None')) {

                    tab.AdvanceSearch.splice(tab.AdvanceSearch.indexOf(advanceSearch), 1);

                } else if ((headerName === 'All' || headerName === 'None') && header.IsFiltered) {

                    allFilters.FilterData.map(filterData => {
                        filterData.IsFiltered = !isFilterChecked;
                        advanceSearch = tab.AdvanceSearch.find(x => x.PropertyValue === filterData.Id
                            && x.PropertyName === filterName);
                        if (advanceSearch === undefined) {
                            tab.AdvanceSearch.push({
                                PropertyName: allFilters.FilterName,
                                PropertyValue: filterData.Id
                            });
                        }
                    });
                } else if ((headerName === 'All' || headerName === 'None') && !header.IsFiltered) {
                    allFilters.FilterData.map(filterData => {
                        filterData.IsFiltered = !isFilterChecked;
                        advanceSearch = tab.AdvanceSearch.find(x => x.PropertyValue === filterData.Id
                            && x.PropertyName === filterName);
                        if (advanceSearch !== undefined) {
                            tab.AdvanceSearch.splice(tab.AdvanceSearch.indexOf(advanceSearch), 1);
                        }
                    });
                }

            } else {
                header.IsVisible = !isFilterChecked;
            }
        }
    });

    return dispatch => {
        dispatch({
            requestForId,
            tabsData,
            isFilterChecked: !isFilterChecked,
            filterPreviousData,
            type: ActionTypes.ON_CHECK_FILTER_COLUMN
        });
    };
}

export function onTextFilter(
    tabsData,
    requestForId,
    headerName,
    isFilterChecked,
    isFilter,
    filterName,
    filterId
) {
    const tab = tabsData.find(x => x.Id === requestForId);
    const filterPreviousData = store.getState().tickets.filterPreviousData;
    tab.QueueViewGrid.Columns.map(header => {
        if (isFilter) {
            const advanceSearch = tab.AdvanceSearch.find(
                x => x.PropertyName === filterName
            );

            if (advanceSearch === undefined) {
                tab.AdvanceSearch.push({
                    PropertyName: filterName,
                    PropertyValue: headerName
                });
            } else {
                advanceSearch.PropertyValue = headerName;
            }
        }
    });
    return dispatch => {
        dispatch({
            requestForId,
            tabsData,
            filterPreviousData,
            type: ActionTypes.ON_CHECK_FILTER_COLUMN
        });
    };
}

export function removeDeletedTab(tabsData, requestForId) {
    return dispatch => {
        dispatch({
            tabsData,
            requestForId,
            type: ActionTypes.REMOVE_TAB
        });
    };
}

export function removeTab(deleteTabId) {
    const tabsData = store.getState().tickets.tabsData;
    const userInfo = store.getState().tickets.UserDetails;
    const requestForId = tabsData.find(x => x.Sequence === 1).Id;
    const tab = tabsData.find(x => x.Id === deleteTabId);
    tabsData.splice(tabsData.indexOf(tab), 1);

    const advanceSearch = tabsData.find(x => x.Sequence === 1).AdvanceSearch;
    const rowcountAfterDelete = tabsData.length;
    for (let i = 4; i < rowcountAfterDelete; i++) {
        tabsData[i].Sequence = i + 1;
    }
    updateTabDetails({ UserId: userInfo.UserId, DynamicTabs: tabsData });
    return dispatch => {
        dispatch(removeDeletedTab(tabsData, requestForId));
        //  updateTabDetails({ UserId: userInfo.UserId, DynamicTabs: tabsData });
        dispatch(fetchTicketsData(
            store.getState().tickets.startIndex,
            store.getState().tickets.pageSize, null,
            store.getState().tickets.sortColumn,
            store.getState().tickets.sortDirection,
            store.getState().tickets.requestForId,
            advanceSearch, null, false, 1
        ));
    };
}

export function clearErrors(eventName) {
    const errors = store.getState().tickets.errors;
    const eventErrors = errors.find(x => x.eventName === eventName);
    eventErrors.errorMessage = [];
    return dispatch => {
        dispatch({
            errors,
            type: ActionTypes.CLEAR_ERRORS
        });
    };
}

export function printTicket(ticketId) {
    const userInfo = store.getState().tickets.UserDetails;
    const queryParams = {
        TaskId: ticketId,
        id: userInfo.UserId
    };
    window.open(getPrintTicketUrl() + Request.getQueryParamString(queryParams));
}

export function openTicket(ticketId, strSessionId) {
    const userInfo = store.getState().tickets.UserDetails;
    const queryParams = {
        strSessionId: strSessionId.query.strSessionId,
        NocUserName: userInfo.UserName,
        TicketNumber: ticketId
    };
    window.open(getOpenTicketUrl() + Request.getQueryParamString(queryParams));
}


export function trimingWhiteSpace(tabName) {
    const newtabName = tabName.replace(/(^|\s)([a-z])/g, function (m, p1, p2) { return p1 + p2.toUpperCase(); });
    return newtabName;
}

function validateTabName(tabName, exisitingTabName) {
    let errorMessage = '';
    const reg = /^[A-Za-z-_'\d\s\']+$/;
    // tabName.replace(/[“”‘’]/g,'');
    if (tabName.trim().length < 3) {
        errorMessage = ' Minimum 3 characters required';
    } else if (!reg.test(tabName)) {
        errorMessage = ' Avoid special characters';
    } else if (tabName.trim().length > 20) {
        errorMessage = ' Max 20 characters allowed';
    }

    if (exisitingTabName !== null && exisitingTabName !== undefined) {
        errorMessage = 'Tab name already exists';
    }

    return errorMessage;
}

export function swapTab(tabsData, requestForId, columnFilters) {
    return dispatch => {
        dispatch({
            tabsData,
            requestForId,
            columnFilters,
            type: ActionTypes.SWAP_TAB
        });
    };
}

export function swapCustomTabs(tabIdToBeSwap) {
    const tabsData = store.getState().tickets.tabsData;
    // const userInfo = store.getState().tickets.userDetails;
    let requestForId = store.getState().tickets.requestForId;
    const tabsDataToBeSwap = tabsData.find(x => x.Id === tabIdToBeSwap);
    const tabsToBeShown = store.getState().tickets.tabsToBeShown + 1;
    const columnFilters = store.getState().tickets.columnFilters;
    const tabsDataToBeSwapWith = tabsData.find(x => x.Sequence === tabsToBeShown);
    const advanceSearch = tabsData.find(x => x.Id === tabIdToBeSwap).AdvanceSearch;
    const tmpSequence = tabsDataToBeSwap.Sequence;
    tabsDataToBeSwap.Sequence = tabsDataToBeSwapWith.Sequence;
    tabsDataToBeSwapWith.Sequence = tmpSequence;
    requestForId = tabsDataToBeSwap.Id;
    columnFilters.find(x => x.eventName === 'morePopupView').isStatus = false;

    return dispatch => {
        dispatch(swapTab(tabsData, requestForId, columnFilters));
        //  updateTabDetails({ UserId: userInfo.UserId, DynamicTabs: tabsData });
        dispatch(fetchTicketsData(
            store.getState().tickets.startIndex,
            store.getState().tickets.pageSize, null,
            store.getState().tickets.sortColumn,
            store.getState().tickets.sortDirection,
            store.getState().tickets.requestForId,
            advanceSearch, null, false, 1
        ));
    };
}


export function saveNewTab(tabName) {
    const newTabName = trimingWhiteSpace(tabName.trim().toLowerCase());
    let requestForId = store.getState().tickets.requestForId;
    const userInfo = store.getState().tickets.UserDetails;
    const tabsData = store.getState().tickets.tabsData;
    const tab = tabsData.find(x => x.Id === store.getState().tickets.requestForId);
    const tabsToBeShown = store.getState().tickets.tabsToBeShown + 1;
    const exisitingTabName = tabsData.find(x => x.DisplayName === newTabName);
    const errors = store.getState().tickets.errors;
    const saveNewErrors = errors.find(x => x.eventName === 'saveNewTab');
    saveNewErrors.errorMessage = [];

    const validateTab = validateTabName(newTabName, exisitingTabName);
    if (validateTab !== '') {
        saveNewErrors.errorMessage.push(validateTab);
    } else {
        saveNewErrors.errorMessage = [];
        let newTabId = '';
        const getMaxSequence = Math.max(...tabsData.map(function (obj) { return obj.Sequence; }));
        if (tabsData.length > 4) {
            newTabId = Number(tabsData[tabsData.length - 1].Id.substring(3, 6));
        } else {
            newTabId = store.getState().tickets.tabsToBeShown;
        }

        const tabId = `tab00${newTabId + 1}`;

        tabsData.push({
            Id: tabId,
            Name: JSON.parse(JSON.stringify(tab.Name)),
            DisplayName: newTabName,
            Sequence: getMaxSequence + 1,
            IsVisible: 'true',
            Grid: JSON.parse(JSON.stringify(tab.QueueViewGrid)),
            AdvanceSearch: JSON.parse(JSON.stringify(tab.AdvanceSearch)),
            IsCustom: true
        });

        (tabsData.length !== tabsToBeShown) ? swapCustomTabs(tabId) : null;
        requestForId = tabId;
        toggle(store.getState().tickets.columnFilters, 'saveNewView');
        updateTabDetails({ UserId: userInfo.UserId, DynamicTabs: tabsData });
    }
    const startTime = Date.now();
    const elapsed = 0;
    return dispatch => {
        //    updateTabDetails({ UserId: userInfo.UserId, DynamicTabs: tabsData });
        dispatch({
            tabsData,
            errors,
            requestForId,
            startTime,
            elapsed,
            type: ActionTypes.SAVE_NEWTAB
        });
    };
}

export function editTab(tabId, editedName) {
    editedName = trimingWhiteSpace(editedName.trim().toLowerCase());
    const userInfo = store.getState().tickets.UserDetails;
    const tabsData = store.getState().tickets.tabsData;
    const errors = store.getState().tickets.errors;
    const renameTabErrors = errors.find(x => x.eventName === 'renameTab');
    const tabSelected = tabsData.find(x => x.Id === tabId);
    const exisitingTabName = tabsData.find(x => x.DisplayName === editedName);

    if (tabSelected.DisplayName !== editedName) {
        const validateTab = validateTabName(editedName, exisitingTabName);
        if (validateTab !== '') {
            renameTabErrors.errorMessage.push(validateTab);
        } else if (tabSelected.DisplayName !== editedName) {
            renameTabErrors.errorMessage = [];
            tabSelected.DisplayName = editedName;
        }
    }

    updateTabDetails({ UserId: userInfo.UserId, DynamicTabs: tabsData });

    return dispatch => {
        //  updateTabDetails({ UserId: userInfo.UserId, DynamicTabs: tabsData });
        dispatch({
            tabsData,
            errors,
            type: ActionTypes.EDIT_TAB
        });
    };
}

export function getFilteredData(tabsData, requestForId) {
    const tab = tabsData.find(x => x.Id === requestForId);

    return dispatch => {
        dispatch(fetchTicketsData(0,
            store.getState().tickets.pageSize,
            store.getState().tickets.filter,
            null, null, requestForId, tab.AdvanceSearch,
            store.getState().tickets.sortOrders, false, 1));
    };
}

export function refresh() {
    const requestForId = store.getState().tickets.requestForId;
    const tabsData = store.getState().tickets.tabsData;
    const tab = tabsData.find(x => x.Id === requestForId);

    return dispatch => {
        dispatch(fetchTicketCategoryData());
        dispatch(fetchTicketsData(
            0,
            store.getState().tickets.pageSize,
            store.getState().tickets.filter,
            null, null, requestForId, tab.AdvanceSearch,
            store.getState().tickets.sortOrders, false, 1));
    };
}

export function setElapsedTime() {
    const startTime = store.getState().tickets.startTime;
    const elapsed = Date.now() - startTime;
    return dispatch => {
        dispatch({
            elapsed,
            type: ActionTypes.SET_ELAPSED_TIME
        });
    };
}

export function filteredDataColumns(
    tabsData,
    requestForId,
    filterName,
    columnFilters
) {
    return dispatch => {
        dispatch(saveFilterInfo());
        dispatch(getFilteredData(tabsData, requestForId));
        dispatch(toggle(columnFilters, filterName));
        dispatch(clearTicketsSelection());
    };
}

export function renderRemainingTime(remainingTime) {
    let result = '\u2014';
    let isMissed = false;
    let isUrgent = false;
    let isPickup = false;
    let isIconVisible = true;

    if (remainingTime === null || remainingTime === undefined || remainingTime === '\u2014' || remainingTime === '-' || remainingTime === '') {
        result = '\u2014';
        isIconVisible = false;
    } else {
        const ftime = remainingTime.split(':');
        const deltaTimeDiffHours = parseInt(ftime[0], 10);
        const deltaTimeDiffMinutes = parseInt(ftime[1], 10);

        result = remainingTime;

        if (deltaTimeDiffHours >= 1) {
            isPickup = true;
        } else if (deltaTimeDiffHours < 1) {
            isUrgent = !!((deltaTimeDiffMinutes >= 1 && deltaTimeDiffMinutes <= 60));
        }
    }

    if (remainingTime === '00:00') {
        result = '00:00';
        isMissed = true;
    }

    const iconClasses = classNames({
        'cn-status': isIconVisible,
        'cn-session--missed': isMissed,
        'cn-session--urgent': isUrgent,
        'cn-session--pickup': isPickup
    });

    return (<span className={iconClasses} > {result} </span>);
}

export function renderSLA(sla) {
    let resultText = '';
    let resultTitle = '';
    let isSLAOnClass = false;
    const isSLAIconVisible = true;
    let isInactive = false;
    let isStatus = false;
    let isDark = false;

    if (sla === 'Complete 24x7') {
        isSLAOnClass = true;
        resultText = 'icon-hours-247';
        resultTitle = 'Hours: 24/7';
    } else if (sla === 'Primary') {
        isSLAOnClass = true;
        resultText = 'icon-hours-day';
        resultTitle = 'Hours: Day';
    } else if (sla === 'After-Hours') {
        isSLAOnClass = true;
        resultText = 'icon-hours-eve';
        resultTitle = 'Hours: Evening';
    } else if (sla === 'No Service Desk Support') {
        isInactive = true;
        resultText = 'icon-stop';
        resultTitle = 'No Help Desk Support Defined';
    } else if (sla === '-') {
        isStatus = true;
        isDark = true;
        resultText = 'icon-adhoc';
        resultTitle = 'Adhoc Site';
    }

    const iconClasses = classNames({
        'cn-badge': isSLAIconVisible,
        'cn-badge--sla-on': isSLAOnClass,
        'cn-badge--inactive': isInactive,
        'cn-badge--status': isStatus,
        'cn-badge--dark': isDark
    });

    return (<span
        className={iconClasses}
        title={resultTitle}
    > {<Icon
        icon={resultText}
    />
        } </span>
    );
}

export function renderSLAZONE(slazone) {

    let resultText = '';
    let resultTitle = '';

    if (slazone === 'NoCoverage') {
        resultText = '';
        resultTitle = 'NoCoverage';
    } else if (slazone === 'USOnly') {
        resultText = 'icon-sla-us';
        resultTitle = 'USOnly';
    } else if (slazone === 'GlobalSupport') {
        resultText = 'icon-globe';
        resultTitle = 'GlobalSupport';
    }

    return (
        <span
            title={resultTitle}
        >
            {<Icon icon={resultText} />}
        </span>
    );
}

export function clearFilters() {
    const tabsData = store.getState().tickets.tabsData;
    const requestForId = store.getState().tickets.requestForId;
    const tab = tabsData.find(x => x.Id === requestForId);
    tab.QueueViewGrid.GridFilters.forEach(filter => {
        onCheckedOfColumnFilter(tabsData, requestForId, 'None', true, true, filter.filterName, filter.FilterId);
    });

    tab.AdvanceSearch = [];
    return dispatch => {
        dispatch(saveFilterInfo());
        dispatch(fetchTicketsData(
            0,
            store.getState().tickets.pageSize,
            store.getState().tickets.filter,
            null, null, requestForId, store.getState().tickets.AdvanceSearch,
            store.getState().tickets.sortOrders, false, 1));
        dispatch(clearTicketsSelection());
    };
}

export function pageKeyPress(event) {
    return dispatch => {
        const columnFilters = store.getState().tickets.columnFilters;
        const openFilters = columnFilters.filter(columnfilter =>
            columnfilter.eventName !== 'TabFilter' && columnfilter.isStatus);

        if (event.keyCode === 27 && openFilters.length > 0) {

            const itemNameToBeToggled = openFilters[0].eventName;
            const requestForId = store.getState().tickets.requestForId;
            const tabsData = store.getState().tickets.tabsData;
            const filterPreviousData = store.getState().tickets.filterPreviousData;

            dispatch(undoFilterInfo());
            dispatch({
                requestForId,
                tabsData,
                filterPreviousData,
                type: ActionTypes.ON_CHECK_FILTER_COLUMN
            });
            dispatch(hideAllPopUp({ hideFilterMenu: false }));
        }
    };
}

export default {
    getAllData,
    getTabData,
    dataSort,
    dataSearch,
    getAuthenticatedUnquieKey,
    fetchTicketsData,
    fetchUserDefaults,
    pageNumberChange,
    // pageSizeChange,
    loadUserSessionData,
    onCheckedOfColumnFilter,
    onTextFilter,
    getFilteredData,
    renderRemainingTime,
    renderSLA,
    renderSLAZONE,
    loadErrorMessage,
    toggle,
    saveNewTab,
    removeTab,
    swapCustomTabs,
    clearErrors,
    editTab,
    refresh,
    setElapsedTime,
    printTicket,
    clearFilters,
    openTicket,
    updateTabDetails,
    filteredDataColumns,
    refreshTechnician,
    fetchTicketTechData,
    refreshGrid,
    changeOwnerTeam,
    changeCell,
    startResetTimer,
    pageKeyPress,
    fetchTicketCountData

};



// WEBPACK FOOTER //
// ./app/tickets/actions.js